import AjudaCategoriaService from "@/services/AjudaCategoriaService";

export const ajudaCategoria = {
  namespaced: true,
  state: {
    ajudaCategoria: {},
  },
  actions: {
    getAjudaCategoria({ commit }, payload) {
      return AjudaCategoriaService.GetAjudaCategoria(payload).then(
        (ajudaCategoria) => {
          return Promise.resolve(ajudaCategoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAjudaCategoria({ commit }, payload) {
      return AjudaCategoriaService.PostAjudaCategoria(payload).then(
        (ajudaCategoria) => {
          return Promise.resolve(ajudaCategoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAjudaCategoria({ commit }, payload) {
      return AjudaCategoriaService.PutAjudaCategoria(payload).then(
        (ajudaCategoria) => {
          return Promise.resolve(ajudaCategoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAjudaCategoria({ commit }, payload) {
      return AjudaCategoriaService.DeleteAjudaCategoria(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAjudaCategoriaOData({ commit }, payload) {
      return AjudaCategoriaService.GetAjudaCategoriaOData(payload).then(
        (ajudaCategoria) => {
          return Promise.resolve(ajudaCategoria);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ajudaCategoria;
